var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('b-row',{staticClass:"skeleton"},[_c('b-col',{staticClass:"content",attrs:{"md":"12"}},_vm._l((_vm.rowCount),function(index){return _c('div',{key:index,class:{
                    'm-0': index === _vm.rowCount,
                    smaller: index % 2 === 0
                }})}),0)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }